import { Banner, Button, TextField, Typography } from '@riac/design-system';
import React, { useCallback, useState } from 'react';
import { LoginToUse } from 'src/components/LoginToUse/LoginToUse';
import { useFetch } from 'src/lib/FetchContext';

export const DetailPageQuestionSection = ({auctionItemId}: {auctionItemId: number}) => {
  const [question, setQuestion] = useState('');
  const [questionResult, setQuestionResult] = useState<{
    variant: "success" | "error" | "primary" | "warning",
    message: string
  }>({
    variant: 'success',
    message: '',
  });
  const {fetch} = useFetch();
  const submitQuestion = useCallback(() => {
    setQuestionResult({
      variant: 'success',
      message: '',
    })
    fetch('/api/detail/question', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        questionText: question,
        auctionItemId,
      }),
    }).then((res) => {
      if (res.status === 200) {
        setQuestion('');
        setQuestionResult({
          variant: 'success',
          message: 'Question submitted. Our team will respond to you as soon as possible.',
        })
      } else {
        setQuestionResult({
          variant: 'error',
          message: 'There was an error submitting your question. Please try again later or contact us a different way',
        })
      }
    })
  }, [question, auctionItemId]);

  return (
    <LoginToUse
      overlayText='Log In or Create an Account to ask a question about this lot'
      className='w-full'
      childrenWrapperClassName='flex flex-col gap-3 px-2'
    >
      <Typography size='sm' heading weight='bold'>Ask a Question</Typography>
      <TextField
        rows={6}
        multiline
        placeholder='Type your question here'
        value={question}
        onChange={(e) => setQuestion(e)}
      />
      <Button className='place-self-stretch sm:place-self-end' onPress={submitQuestion} isDisabled={!question}>
        Submit Question
      </Button>
      {questionResult.message && <Banner size='sm' color={questionResult.variant}>
        {questionResult.message}
      </Banner>}
    </LoginToUse>
  )
}